import { render } from "./ProductCatalog.vue?vue&type=template&id=2da55acf&scoped=true"
import script from "./ProductCatalog.vue?vue&type=script&lang=js"
export * from "./ProductCatalog.vue?vue&type=script&lang=js"

import "@/assets/css/product-catalog.css?vue&type=style&index=0&lang=css"
import "./ProductCatalog.vue?vue&type=style&index=1&id=2da55acf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da55acf"]])

export default __exports__